import styled from 'styled-components';
import Logo from '../../assets/img/logo.jpeg'
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import { Slide } from 'react-reveal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormikComponent from '../React/Formik/FormikComponent';
import FormComponent from '../React/Formik/FormComponent';
import * as yup from "yup";
import { useState } from 'react';
import { emailRegx, passwordRegx } from '../../utils/regEx-pattern/regEx-pattern';
import TokenService from '../../services/jwt-token/jwt-token';
import { postData } from '../Api/CommonApi';
import { loginUser } from "../Api/Links";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoginStatus from '../../redux/actions';
import SlideComponent from '../React/Toast/SlideComponent';

const loginFields = [
    {
        label: "Email",
        name: "email",
        type: "text"
    },
    {
        label: "Password",
        name: "password",
        type: "password"
    }
]

const loginInitialValues = {
    email: "",
    password: ""
}

const loginValidationSchema = yup.object({
    email: yup.string().matches(emailRegx, "Please input valid email").required("Required"),
    password: yup.string().matches(passwordRegx, "Password must contains at least 8 characters, 1 uppercase letter, 1 lowercase letter, and 1 number").required("Required"),
});

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState({
        messageType: "success",
        message: "operation success",
    });

    const handleSubmit = (values) => {
        console.log(values, "values");
        // let email = values.user;
        // console.log(emailRegx?.test(email), "validation");
        // let userKey = (emailRegx?.test(email) && "email") || "user" 
        let body = {
            ...values
        }
        delete body.user;
        let headerContentType = "application/json";
        setIsLoading(true);

        postData(
            loginUser,
            body,
            headerContentType,
            (res) => {
                console.log(res, "res");
                setIsLoading(false);
                if (res.data.status === "success") {
                    TokenService.setToken(res.data.accessToken)
                    dispatch(LoginStatus(true));
                    console.log("inside ")
                    navigate("/", { state: { messageType: res.data.status, message: res.data.message } });
                }
            },
            (err) => {
                console.log(JSON.stringify(err, null, 2));
            }
        );
    }
    return (
        <section className="container-fluid login-container-fluid">
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <Container className='container'>
                <div>
                    <Slide left>

                        <img src={Logo} alt="" />
                        <FormikComponent
                            initialValues={loginInitialValues}
                            validationSchema={loginValidationSchema}
                            onSubmit={handleSubmit}
                        >
                            <PersonIcon style={{ fontSize: '40px' }} /> <br />
                            {loginFields.map((item, index) => (
                                <div key={index}>
                                    <label
                                        for={item.name}
                                        id={item.name}
                                    >
                                        {item.label}
                                    </label>
                                    <FormComponent
                                        type={item.type}
                                        name={item.name}
                                        label={item.label}
                                    />
                                </div>
                            ))}
                            <div className="d-flex justifiy-content-end">
                                <button
                                    type='submit'
                                >
                                    {isLoading && (
                                        <i class="fa fa-circle-o-notch fa-spin text-white mr-2"></i>
                                    )}
                                    LOG IN
                                </button>
                            </div>
                            <HavingTrouble>
                                <p>
                                    <Link to="../membership">Not Registered Yet?</Link>
                                    |
                                    <Link to='/forgotpassword'>Forgot Password?</Link>
                                </p>
                            </HavingTrouble>
                        </FormikComponent>
                        {/* <form action="/">
                            <PersonIcon style={{ fontSize: '40px' }} /> <br />
                            <label htmlFor="" id='login-label'>Username or Email</label>
                            <input type="email" placeholder='Your Email or Username' />

                            <label htmlFor="" id='login-label'>Password</label>
                            <input type="password" placeholder='Your Password' />

                            <button type='submit'>LOG IN</button>

                            <HavingTrouble>
                                <p>
                                    <Link to="../membership">Not Registered Yet?</Link>
                                    |
                                    <Link to='/forgotpassword'>Forgot Password?</Link>
                                </p>
                            </HavingTrouble>

                        </form> */}
                    </Slide>
                </div>
                <Slide right>

                    <JoinContainer>
                        <h1 id='launch-idea'>Launch Your Idea</h1>
                        <p>Get Started as an early stage entrepreneur? Join Our entrepreneurial Workshop Sessions Today.</p>
                        <button>YES, SHOW ME HOW TO START<br /> </button>
                    </JoinContainer>
                </Slide>
            </Container>
            {showAlert && (
                <SlideComponent
                    transition="left"
                    show={showAlert}
                    handleClose={() => {
                        setShowAlert(false);
                    }}
                    messageType={message.messageType}
                    message={message.message}
                />
            )}
        </section>
    )
}

export default Login;
const JoinContainer = styled.div`
        h1{

            font-family: 'Lobster', cursive;
            font-size:4em ;
        }
        p{
            font-weight:bold ;
            font-size:22px ;
        }
        margin-top:10em;

        #launch-idea{
            color:black ;
        }

        @media (max-width:1000px){
            h1{
                font-size:3em ;
            }
            p{
                font-size:1em ;
            }
        }

`
const HavingTrouble = styled.div`
            a{
                margin:5px;
                text-decoration:none ;
                &:hover{
                    color:#fa7525 ;
                }
            }
`

const Container = styled.div`
display:grid ;
grid-template-columns: repeat(auto-fit, minmax(350px,1fr));
text-align:center ;
font-family: Montserrat bold;
padding-top:30px ;
margin-top:40px ;

        label{
            font-size:18px ;
        }
        img{
            /* width:400px ; */
            width:18em;
            height:60px;
            object-fit:cover ;
            margin-bottom:25px ;
        }
        button{
            background-color:#fa7525 ;
            border:none ;
            padding:10px 20px 10px 20px;
            margin:10px ;
            width:90%;
            border-radius:5px ;
            &:hover{
                background-color: black;
                color:#fa7525;

            }

        }

        input{
            width:90% ;
            height: 45px;
            box-sizing:border-box ;
            margin: 10px;
            padding-left:10px ;
            outline:none ;
            border:1px solid rgb(211, 211, 211) ;
            &:focus{
                border:1px solid #fa7525;
            }
            &:hover{
                border:1px solid #fa7525 ;
            }


        }
            form{
                border:1px solid rgb(211, 211, 211) ;
                width:80% ;
                margin: auto;
                padding:20px ;
                border-radius:5px ;
                box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;  
            }

            form #login-label{
                color:black ;
            }


`
